import { defaultErrorMessage } from "@utils/textDefaults"
import { Alert, AlertDescription, AlertTitle } from "./ui/alert"
import { AlertCircleIcon } from "lucide-react"

interface IErrorMessageProps {
  title?: string
  message?: string
  variant?: "destructive" | "destructive-secondary"
}

const ErrorMessage = ({
  title,
  message = defaultErrorMessage,
  variant = "destructive",
}: IErrorMessageProps) => {
  return (
    <Alert variant={variant}>
      {title && (
        <>
          <AlertCircleIcon />
          <AlertTitle>{title}</AlertTitle>
        </>
      )}
      <AlertDescription>
        <span>{message}</span>
      </AlertDescription>
    </Alert>
  )
}

export default ErrorMessage
